import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/Index';

Vue.use(Router);
const platformTitle = window.settings.title || '灯翼智能';
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: platformTitle,
      },
    },
  ],
});
